import { api } from "@/lib/api";

const TYPES = ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/heif"];
const EXTS = ["pdf", "jpg", "jpeg", "png", "heic", "heif"];
export const ACCEPT = ".pdf,.jpg,.jpeg,.png,.heic,.heif,application/pdf,image/jpeg,image/png,image/heic";

const mimeOf = (f) => {
  const ext = f.name.split(".").pop().toLowerCase();
  return f.type || (ext === "heic" || ext === "heif" ? "image/heic" : "");
};

export function checkFile(f) {
  const ext = f.name.split(".").pop().toLowerCase();
  if (!TYPES.includes(mimeOf(f)) || !EXTS.includes(ext) || !f.size || f.size > 25 * 1024 * 1024) return `${f.name} can't be added. PDF or photos up to 25 MB.`;
  return null;
}

// Chunked upload: start → PUT 4 MB parts → returns the upload id to attach.
export async function uploadFile(base, file, headers = {}) {
  const { data } = await api.post(`${base}/uploads`, { name: file.name, mime: mimeOf(file), size: file.size }, { headers });
  for (let n = 0; n < data.parts; n += 1) {
    const part = file.slice(n * data.chunk_size, (n + 1) * data.chunk_size);
    await api.put(`${base}/uploads/${data.id}/parts/${n}`, part, { headers: { ...headers, "Content-Type": "application/octet-stream" } });
  }
  return data.id;
}

export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const fmtSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
